/**
 * Thin TG WebApp wrapper.
 *
 * We use the legacy script (telegram.org/js/telegram-web-app.js) injected in
 * index.html for now — it gives `window.Telegram.WebApp` synchronously without
 * an async init step. The richer `@telegram-apps/sdk` package becomes useful
 * when we add platform-specific UI (bottom bar, swipe behaviour) in Phase 2.
 */
declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        ready: () => void;
        expand: () => void;
        initData: string;
        initDataUnsafe: {
          user?: {
            id: number;
            first_name?: string;
            last_name?: string;
            username?: string;
            photo_url?: string;
          };
          start_param?: string;
        };
        colorScheme: "light" | "dark";
        themeParams: Record<string, string>;
        onEvent: (event: string, cb: () => void) => void;
        HapticFeedback?: {
          impactOccurred: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => void;
          notificationOccurred: (style: "error" | "success" | "warning") => void;
        };
        BackButton: { show: () => void; hide: () => void; onClick: (cb: () => void) => void };
      };
    };
  }
}

export function tg() {
  return window.Telegram?.WebApp;
}

export function isInTelegram(): boolean {
  return typeof window !== "undefined" && !!window.Telegram?.WebApp?.initData;
}

export function initTelegram(): void {
  const wa = tg();
  if (!wa) {
    console.info("[kvin] not in Telegram WebApp — running in browser preview mode");
    return;
  }
  wa.ready();
  wa.expand();
  console.info("[kvin] TG WebApp initialized, user:", wa.initDataUnsafe.user);
}

export function haptic(kind: "light" | "medium" | "heavy" = "light"): void {
  tg()?.HapticFeedback?.impactOccurred(kind);
}

export function tgInitData(): string {
  return tg()?.initData ?? "";
}

export function tgUser() {
  return tg()?.initDataUnsafe.user;
}
